"use client";

import { motion } from "framer-motion";

export default function Manifesto({
  eyebrow,
  statementLine1,
  statementLine2,
  signature,
}: {
  eyebrow: string;
  statementLine1: string;
  statementLine2: string;
  signature: string;
}) {
  return (
    <section className="relative bg-[#0b0b0d] py-32 md:py-40">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center gap-5 mb-16">
          <span className="block h-px w-10 bg-white/20" />
          <span className="text-[10px] tracking-[0.3em] uppercase text-white/35 font-body">
            {eyebrow}
          </span>
          <span className="block h-px w-10 bg-white/20" />
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="font-heading text-4xl md:text-6xl leading-[1.15] font-light text-white"
        >
          {statementLine1}
          <br />
          <span className="italic text-white/85">{statementLine2}</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.2, delay: 0.3, ease: "easeOut" }}
          className="mt-14 text-[11px] tracking-[0.32em] uppercase text-white/40 font-body"
        >
          — {signature}
        </motion.p>
      </div>
    </section>
  );
}
